module.exports = __webpack_public_path__ + "img/6 - VB 1.b586a295.png";